import React, { Component } from 'react'

class Cluster extends Component{
    render(){
    return (
        <div style={{textAlign:"center",marginTop:"50px",marginBottom:"50px"}}>
            <iframe  width="1000" height="600" src="https://data.gov.sg/dataset/dengue-clusters/resource/801ce5ce-fb99-4211-94fe-9d8ca5e182d4/view/07e4bfc9-8675-4534-959f-768be06aeeab" frameBorder="0"> </iframe>
        </div>
    )
}
}
export default Cluster